import { Button } from "@/components/ui/button";
import { Fish } from "lucide-react";

export default function Login() {
  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/forum";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center animate-fade-in" data-testid="login-page">
      <div className="max-w-7xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-0">
        <div className="hidden md:block relative">
          <img
            src="https://images.unsplash.com/photo-1605499907240-d4240d766581"
            alt="Florida angler"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-primary/70 via-primary/40 to-transparent" />
          <div className="absolute bottom-10 left-10 right-10 text-primary-foreground">
            <div className="text-xs uppercase tracking-widest opacity-80">Sign in</div>
            <div className="font-display font-extrabold text-4xl mt-2 leading-tight">
              The tribe's already fishing. Grab your rod.
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center px-6 py-16 md:py-0">
          <div className="w-full max-w-md">
            <div className="flex items-center gap-2 mb-8">
              <div className="w-10 h-10 rounded-md bg-primary flex items-center justify-center">
                <Fish className="w-5 h-5 text-primary-foreground" />
              </div>
              <span className="font-display font-extrabold text-lg">Florida Sportsman</span>
            </div>
            <h1 className="font-display font-extrabold text-4xl tracking-tight">Welcome back.</h1>
            <p className="mt-3 text-muted-foreground">
              One-click sign in with Google. No passwords, no forms, no runaround.
            </p>

            <Button
              onClick={handleGoogle}
              size="lg"
              data-testid="btn-google-signin"
              className="mt-8 h-12 w-full bg-foreground text-background hover:bg-foreground/90"
            >
              <svg className="w-5 h-5 mr-3" viewBox="0 0 48 48">
                <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.8 32.4 29.4 35.5 24 35.5c-6.3 0-11.5-5.2-11.5-11.5S17.7 12.5 24 12.5c2.9 0 5.5 1.1 7.5 2.9l5.7-5.7C33.7 6.4 29.1 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5c10.8 0 19.5-8.7 19.5-19.5 0-1.2-.1-2.3-.4-3.5z"/>
                <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.9 19 12.5 24 12.5c2.9 0 5.5 1.1 7.5 2.9l5.7-5.7C33.7 6.4 29.1 4.5 24 4.5 16.3 4.5 9.7 8.9 6.3 14.7z"/>
                <path fill="#4CAF50" d="M24 43.5c5 0 9.6-1.9 13.1-5l-6-5c-2 1.4-4.4 2.2-7.1 2.2-5.4 0-9.8-3.1-11.3-7.5l-6.5 5C9.7 39.1 16.3 43.5 24 43.5z"/>
                <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.4-2.4 4.4-4.4 5.7l6 5c-.4.4 6.6-4.8 6.6-14.7 0-1.2-.1-2.3-.5-3.5z"/>
              </svg>
              Continue with Google
            </Button>

            <p className="mt-8 text-xs text-muted-foreground leading-relaxed">
              By signing in you agree to our{" "}
              <a href="/terms" className="underline hover:text-primary" data-testid="link-terms">Terms of Service</a>,{" "}
              <a href="/privacy" className="underline hover:text-primary" data-testid="link-privacy">Privacy Policy</a>{" "}
              and{" "}
              <a href="/rules" className="underline hover:text-primary" data-testid="link-rules">Community Rules</a>.
              Keep it friendly, no scams, no illegal listings.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
